import * as React from 'react';

interface LinkPreviewInfoProps {
  eyebrow?: string;
  meta?: string;
  subtitle?: string;
  title: string;
}

export const LinkPreviewInfo: React.FC<LinkPreviewInfoProps> = ({ eyebrow, title, subtitle, meta }) => (
  <div className="link-preview-info">
    {eyebrow && <div className="link-preview-eyebrow">{eyebrow}</div>}
    <div className="link-preview-title">{title}</div>
    {subtitle && <div className="link-preview-subtitle">{subtitle}</div>}
    {meta && <div className="link-preview-meta">{meta}</div>}
  </div>
);
